import { useState, useEffect, useCallback } from "react";

const FIELD_MODE_KEY = "quotrak:field-mode";
const FIELD_MODE_EVENT = "quotrak:field-mode-change";

export function useFieldMode() {
  const [fieldMode, setFieldModeState] = useState(
    () => localStorage.getItem(FIELD_MODE_KEY) === "1",
  );

  useEffect(() => {
    const handler = () => {
      setFieldModeState(localStorage.getItem(FIELD_MODE_KEY) === "1");
    };
    window.addEventListener(FIELD_MODE_EVENT, handler);
    return () => window.removeEventListener(FIELD_MODE_EVENT, handler);
  }, []);

  const setFieldMode = useCallback((value: boolean) => {
    if (value) {
      localStorage.setItem(FIELD_MODE_KEY, "1");
    } else {
      localStorage.removeItem(FIELD_MODE_KEY);
    }
    window.dispatchEvent(new Event(FIELD_MODE_EVENT));
  }, []);

  return { fieldMode, setFieldMode };
}
